import { Skeleton } from '@mui/material'
export default function ProgressCardSkeleton() {
  // #e2e8f0
  return (
    <>
      <Skeleton variant="rectangular" animation="wave" height={'110px'} width={'100%'} sx={{ borderRadius: '10px', background: '#e2e8f0' }} />
    </>
  )
}
